import React from "react";
import AIModuleFiles from "./aiModuleFiles";
import {useSelector} from "react-redux";
import AIModuleMyDataClearance from "./aiModuleMyDataClearance";

const AIModule = () => {
    const aiModuleType = useSelector((state) => state.AI.aiModuleType);

    return (
        <React.Fragment>
            {aiModuleType === "files" ? (
                <AIModuleFiles />
            ) : aiModuleType === "myDataClearance" ? (
                <AIModuleMyDataClearance />
            ) : (
                <React.Fragment></React.Fragment>
            )}
        </React.Fragment>
    )
}

export default AIModule;
